module.exports = __webpack_public_path__ + "static/media/CTS.cbf4e1cd.jpg";